import { AuthTokenType } from 'Components/Auth/types';

const AUTH_TOKEN_TYPE_LOCAL_STORAGE_KEY = 'PTAuthTokenType';

export const getAuthTokenTypeLocalStorage = () => localStorage.getItem(AUTH_TOKEN_TYPE_LOCAL_STORAGE_KEY);

export const setAuthTokenTypeLocalStorage = (authTokenType: AuthTokenType | null) =>
    authTokenType
        ? localStorage.setItem(AUTH_TOKEN_TYPE_LOCAL_STORAGE_KEY, authTokenType)
        : localStorage.removeItem(AUTH_TOKEN_TYPE_LOCAL_STORAGE_KEY);

export const isOktaInternalAuthToken = () => getAuthTokenTypeLocalStorage() === AuthTokenType.OktaInternal;

export const isOktaExternalAuthToken = () => getAuthTokenTypeLocalStorage() === AuthTokenType.OktaExternal;
